{
  "friendsScreen": {
    "tabs": {
      "suggestions": "Suggestions",
      "search": "Search",
      "requests": "Requests"
    },
    "common": {
      "loading": "Loading…"
    },
    "suggestions": {
      "sectionTitle": "People you might know",
      "empty": "No suggestions for now",
      "endOfList": "— End of suggestions —"
    },
    "search": {
      "placeholder": "Search by first or last name…",
      "sectionTitle": "Search results",
      "noResults": "No results for \"{{query}}\"",
      "hint": "Find new people"
    },
    "requests": {
      "receivedTab": "Received ({{count}})",
      "sentTab": "Sent ({{count}})",
      "receivedSubtitle": "Wants to connect with you",
      "sentSubtitle": "You sent a request",
      "emptyReceived": "No new requests",
      "emptySent": "No pending requests",
      "accept": "Accept",
      "decline": "Decline",
      "cancel": "Cancel"
    }
  },
  "messagesScreen": {
    "defaultUserName": "Me",
    "loadingData": "Loading data",
    "you": "You:",
    "tabs": {
      "history": "History",
      "online": "Online",
      "friends": "Friends",
      "groups": "Groups"
    },
    "search": {
      "placeholderHistory": "Search a conversation",
      "placeholderOnline": "Search an online friend",
      "placeholderFriends": "Search a friend",
      "placeholderGroups": "Search a group"
    },
    "status": {
      "online": "Online",
      "offline": "Offline"
    },
    "preview": {
      "noMessage": "No message",
      "photo": "📷 Photo",
      "video": "🎬 Video",
      "audio": "🎵 Audio",
      "file": "📁 File"
    },
    "time": {
      "now": "Just now",
      "minutes_one": "{{count}}min",
      "minutes_other": "{{count}}min",
      "hours_one": "{{count}}h",
      "hours_other": "{{count}}h",
      "days_one": "{{count}}d",
      "days_other": "{{count}}d"
    },
    "empty": {
      "noResultsTitle": "No results",
      "noConversationsFor": "No conversation for \"{{query}}\"",
      "noMessagesTitle": "You have no messages",
      "noMessagesSubtitle": "Start a conversation with your friends",
      "noOnlineFriendsFor": "No online friend for \"{{query}}\"",
      "noOnlineFriendsTitle": "No friends online",
      "noFriendsFor": "No friend for \"{{query}}\"",
      "noFriendsTitle": "No friends"
    },
    "sync": {
      "titleInProgress": "Syncing in progress",
      "titleDone": "Data updated",
      "titleError": "Sync failed",
      "done": "Sync successful",
      "genericError": "An error occurred.",
      "steps": {
        "checking": "Initializing…",
        "refreshing": "Refreshing…",
        "syncing": "Syncing data…",
        "syncingData": "Syncing data"
      },
      "errors": {
        "pleaseReconnectData": "Please sign in again to access your data.",
        "pleaseReconnect": "Please sign in again.",
        "cannotRefresh": "Unable to refresh data. Please sign in again.",
        "userNotFound": "User ID not found. Please sign in again.",
        "syncFailed": "An error occurred during synchronization. Check your connection and try again."
      }
    }
  },
  "profileScreen": {
    "loading": "Loading...",
    "retry": "Retry",
    "memberSince": "Member since {{date}}",
    "errors": {
      "cannotLoadProfile": "Unable to load profile"
    },
    "roles": {
      "supreme": "⚡ Supreme",
      "adminPro": "👑 Admin PRO",
      "admin": "🛡 Administrator",
      "pro": "⭐ PRO User"
    },
    "stats": {
      "cfa": "CFA",
      "trophies": "Trophies"
    },
    "account": {
      "sectionLabel": "MY ACCOUNT",
      "topUp": {
        "title": "Top up my balance",
        "sub": "Fast · Secure · Mobile Money"
      },
      "settings": {
        "title": "Settings",
        "sub": "Last name, first name, date of birth"
      },
      "privacy": {
        "title": "Privacy",
        "sub": "Privacy, data & security"
      },
      "guide": {
        "title": "User guide",
        "sub": "Everything about Harmonia"
      }
    },
    "info": {
      "sectionLabel": "INFORMATION",
      "lastName": "Last name",
      "firstName": "First name",
      "birthDate": "Date of birth"
    },
    "posts": {
      "title": "Posts ({{count}})",
      "publishButton": "Post",
      "emptyTitle": "No posts",
      "emptySub": "Share your first post!"
    },
    "post": {
      "tapToPlay": "Tap to play",
      "commentsCount_one": "{{count}} comment",
      "commentsCount_other": "{{count}} comments",
      "sharesCount_one": "{{count}} share",
      "sharesCount_other": "{{count}} shares"
    },
    "postDetails": {
      "title": "📊 Details",
      "author": "Author:",
      "published": "Published:",
      "reactions": "Reactions:",
      "close": "Close"
    },
    "avatar": {
      "updated": "Profile photo updated!",
      "errors": {
        "accessRequired": "Photo access required.",
        "cannotUpdate": "Unable to update photo"
      }
    },
    "createPost": {
      "title": "New post",
      "placeholder": "What's new?",
      "photo": "Photo",
      "video": "Video",
      "videoReady": "Video ready",
      "publish": "Post",
      "published": "Post published!",
      "imageAdded": "Image added!",
      "videoAdded": "Video added!",
      "visibility": {
        "public": "Public",
        "friends": "Friends",
        "pro": "PRO",
        "private": "Private"
      },
      "errors": {
        "contentRequired": "Content is required",
        "limitReached": "Posting limit reached.",
        "cannotPublish": "Unable to publish",
        "mediaAccessRequired": "Media access required.",
        "cannotAddMedia": "Unable to add media"
      }
    },
    "settings": {
      "header": {
        "title": "Settings",
        "subtitle": "Edit your personal information"
      },
      "updated": "Profile updated!",
      "fields": {
        "lastName": "Last name",
        "lastNamePlaceholder": "Your last name",
        "firstName": "First name",
        "firstNamePlaceholder": "Your first name",
        "birthDate": "Date of birth"
      },
      "language": {
        "label": "Language",
        "intro": "Choose the language you'd like to use Harmonia in. The change applies immediately across the whole app.",
        "options": {
          "fr": { "name": "French", "native": "Français" },
          "en": { "name": "English", "native": "English" },
          "es": { "name": "Spanish", "native": "Español" },
          "pt": { "name": "Portuguese", "native": "Português" }
        }
      },
      "actions": {
        "cancel": "Cancel",
        "save": "Save"
      },
      "errors": {
        "nameRequired": "Last name and first name are required",
        "cannotSave": "Unable to save",
        "cannotChangeLanguage": "Unable to change language"
      }
    }
  },
  "vueProfilModal": {
    "loading": "Loading...",
    "memberSince": "Member since {{date}}",
    "premiumBadge": "Premium",
    "actions": {
      "sendInvite": "Send invitation",
      "cancelRequest": "Cancel request",
      "accept": "Accept",
      "decline": "Decline",
      "removeFriend": "Remove friend"
    },
    "errors": {
      "cannotLoadProfile": "Unable to load profile"
    }
  },
  "chatBox": {
    "retry": "Retry",
    "loadingData": "Loading data",
    "loadingEllipsis": "Loading…",
    "loadPreviousMessages": "View previous messages",
    "messageDeleted": "Message deleted",
    "privateReply": "Private reply",
    "edited": "edited",
    "offlineBanner": "No connection — messages will be resent automatically",
    "status": {
      "typing": "Typing...",
      "typingEllipsis": "Typing…",
      "online": "Online",
      "offline": "Offline",
      "someoneTyping": "Someone is typing...",
      "someoneTypingEllipsis": "Someone is typing…",
      "memberCount_one": "{{count}} member",
      "memberCount_other": "{{count}} members"
    },
    "empty": {
      "title": "No messages",
      "subtitle": "Start the conversation!"
    },
    "replyBar": {
      "publicPrefix": "Public reply to ",
      "privatePrefix": "Private reply to "
    },
    "editBar": {
      "label": "Edit message"
    },
    "input": {
      "placeholder": "Message...",
      "editPlaceholder": "Edit message..."
    },
    "media": {
      "document": "Document",
      "file": "File",
      "voiceNote": "Voice note"
    },
    "recording": {
      "inProgress": "In progress...",
      "inProgressEllipsis": "Recording…"
    },
    "actions": {
      "replyPublicly": "Reply publicly",
      "replyPubliclySub": "The whole group sees the reply",
      "replyPrivately": "Reply privately",
      "replyPrivatelySub": "Visible only to you and the recipient",
      "makePrivate": "Make private",
      "makeVisible": "Make visible",
      "edit": "Edit",
      "editSub": "Possible while unread",
      "delete": "Delete",
      "cancel": "Cancel"
    },
    "errors": {
      "uploadUrlGeneration": "Error generating URL",
      "uploadFailed": "Error during upload",
      "uploadFailedHttp": "Upload failed (HTTP {{status}})",
      "uploadConfirmation": "Confirmation error",
      "transferFailed": "Error during file transfer.",
      "microphonePermission": "Microphone permission required. Check your browser's permissions.",
      "permissionRequired": "Permission required.",
      "cannotStartRecording": "Unable to start recording.",
      "audioFileCreation": "Error creating the audio file."
    }
  },
  "audioFeedModal": {
    "runNumber": "Run #{{number}}",
    "runLabel": "Run #{{number}} — {{title}}"
  },
  "tikTokVideoModal": {
    "runLabel": "Run #{{number}} — {{title}}"
  },
  "commentLikersModal": {
    "loading": "Loading…",
    "likesCount_one": "like",
    "likesCount_other": "likes",
    "likedThisComment": "Liked this comment",
    "likePill": "Like",
    "empty": {
      "title": "No likes yet",
      "subtitle": "Be the first to react!"
    }
  },
  "limitNotification": {
    "titlePro": "PRO limit reached",
    "titleDaily": "Daily limit",
    "upgradeButton": "Go PRO"
  },
  "legalDocumentScreen": {
    "defaultBadgeText": "Official legal document",
    "lastUpdated": "Last updated: {{date}}",
    "sectionsLabel": "SECTIONS",
    "copyright": "© {{year}} Harmonia · All rights reserved",
    "intro": {
      "title": "Your privacy, our priority",
      "text": "Harmonia is committed to protecting your data with the highest rigor. No data is sold or transmitted to commercial third parties."
    },
    "pills": {
      "zeroTracking": "Zero tracking",
      "encrypted": "Encrypted",
      "gdpr": "GDPR",
      "internalAdsOnly": "Internal ads only"
    },
    "contact": {
      "title": "A question about your data?"
    },
    "footer": {
      "privacy": "Privacy",
      "cookies": "Cookies",
      "terms": "Terms",
      "rules": "Rules"
    }
  },
  "shareButton": {
    "title": "Share",
    "sharedOnHarmonia": "Shared on Harmonia ✓",
    "shareWithFriends": "Share with my friends",
    "visibleInFriendsFeed": "Visible in your friends' feed",
    "socialNetworks": "Social networks",
    "more": "More",
    "cancel": "Cancel"
  },
  "submissionCard": {
    "runLabel": "Run #{{number}} — {{title}}",
    "vote": "Vote",
    "voted": "Voted 💪",
    "badges": {
      "arts": "🎨 Arts",
      "artisanat": "🪡 Craftsmanship"
    },
    "mediaBadges": {
      "audio": "Audio",
      "video": "Video",
      "artisanat": "Craftsmanship"
    }
  },
  "publicShopScreen": {
    "loadingShop": "Loading shop…",
    "newBadge": "New",
    "products": "Products",
    "noProducts": "No products published yet.",
    "subscribe": "Subscribe",
    "retry": "Retry",
    "whatsappMessage": "Hello, I'm discovering your shop \"{{name}}\" on Harmonia Market.",
    "errors": {
      "shopNotFound": "This shop doesn't exist or is no longer available.",
      "cannotLoadShop": "Unable to load this shop.",
      "cannotReachServer": "Unable to reach the server."
    }
  },
  "publicProductScreen": {
    "loadingProduct": "Loading product…",
    "newBadge": "New",
    "back": "Back",
    "retry": "Retry",
    "defaultMetaTitle": "Product",
    "descriptionTitle": "Description",
    "inStock_one": "In stock ({{count}})",
    "inStock_other": "In stock ({{count}})",
    "outOfStock": "Out of stock",
    "contactViaWhatsApp": "Contact via WhatsApp",
    "buy": "Buy",
    "learnMore": "Learn more",
    "call": "Call",
    "goToShop": "Go to shop",
    "whatsappMessage": "Hello, I'm interested in \"{{name}}\" on Harmonia Market.",
    "condition": {
      "new": "New",
      "used": "Used",
      "refurbished": "Refurbished"
    },
    "errors": {
      "productNotFound": "This product doesn't exist or is no longer available.",
      "cannotLoadProduct": "Unable to load this product.",
      "cannotReachServer": "Unable to reach the server."
    }
  },
  "commentCaMarcheScreen": {
    "cta": "Create my free account",
    "seo": {
      "title": "How does it work? Complete Harmonia World guide",
      "description": "Discover how Harmonia World works: create your account, take part in talent contests across 6 disciplines, join a creative community, or create your online shop with your own professional website. Complete step-by-step guide.",
      "ogDescription": "Talent contests, creative community, online shops: the complete guide to how Harmonia World works."
    },
    "hero": {
      "titleLine1": "How does",
      "titleLine2": "Harmonia World work?",
      "sub": "Harmonia World is a social platform that brings three worlds together in one place: talent contests open to everyone, an international creative community, and a marketplace letting anyone create their own online shop with a professional website. This guide explains every feature in detail, step by step."
    },
    "presentation": {
      "chip": "OVERVIEW",
      "title": "One platform, three worlds",
      "p1": "Harmonia World is available on web and mobile. It lets every member create a profile, publish content, exchange via messaging and groups, take part in talent contests across six disciplines, play trivia and strategy games, and — for merchants, artisans, and entrepreneurs — create an online shop paired with a real, customizable website.",
      "p2": "The platform rests on a simple conviction: talent has no borders. Every discipline opens the door to regular contests, where members compete with kindness, are supported by community votes, and can see their talent rewarded with publicly awarded trophies."
    },
    "gettingStarted": {
      "chip": "GET STARTED",
      "title": "Creating your account and signing in",
      "step1": {
        "title": "Sign up",
        "desc": "Create your account with your last name, first name, email address, and a date of birth, or sign up directly via Google in one click. Sign-up is open to anyone, anywhere in the world, with no age restriction."
      },
      "step2": {
        "title": "Email verification",
        "desc": "A confirmation email is sent automatically. Just click the received link, then return to the app to permanently activate the account."
      },
      "step3": {
        "title": "Sign in",
        "desc": "Once the account is activated, sign in with the chosen email and password. You can stay signed in to avoid re-entering your credentials each time."
      },
      "step4": {
        "title": "Forgot password",
        "desc": "If forgotten, a reset link is sent by email to securely choose a new password."
      }
    },
    "talentHub": {
      "chip": "TALENT HUB",
      "title": "Six disciplines, contests every week",
      "p1": "The Talent Hub offers active contests spread across six major disciplines. Every week, new challenges open up to all members. Participants submit their creations or compete directly, then the community votes to select the best talents. Contests leading to a physical final stage take place in a country randomly chosen by Harmonia, with an expert jury selected to ensure fairness.",
      "p2": "Harmonia World offers no games of chance. The sole objective of the contests is to reveal and reward genuine talent, judged by community votes and, for finals, by expert juries."
    },
    "disciplines": {
      "strategie": {
        "label": "Strategy Games",
        "tagline": "Pure thought & tactics",
        "desc": "Awalé and Checkers: face your opponents in intense strategy duels."
      },
      "connaissance": {
        "label": "Knowledge",
        "tagline": "Test your knowledge",
        "desc": "True or False: intellectual duels as thrilling as they are unpredictable."
      },
      "arts": {
        "label": "Arts",
        "tagline": "Creativity & expression",
        "desc": "Photography, Drawing, Design: showcase your creations and get the recognition they deserve."
      },
      "performance": {
        "label": "Performance",
        "tagline": "Take the stage",
        "desc": "Comedy, Dance, Theater: embody, captivate, transcend."
      },
      "musique": {
        "label": "Music",
        "tagline": "Make the stage vibrate",
        "desc": "Singing, Piano, Guitar: your voice, your instruments, your mark on the world."
      },
      "artisanat": {
        "label": "Craftsmanship",
        "tagline": "Excellence in craft",
        "desc": "Sewing, Woodworking, Hairstyling, Welding, Mechanics: noble trades, rare mastery."
      }
    },
    "community": {
      "chip": "COMMUNITY",
      "title": "Post, connect, make friends",
      "p1": "The news feed lets every member publish content (text, and for PRO members, photos and videos) with a chosen visibility level: public, visible to friends only, to friends of friends, or strictly private. Posts can be liked, commented on, shared, and saved.",
      "p2": "Harmonia also offers private messaging and discussion groups, as well as a friend system with suggestions, user search, and management of sent or received requests."
    },
    "proSolution": {
      "chip": "PRO SOLUTION",
      "title": "Your shop, your website, your world",
      "p1": "PRO members can create a shop directly from Harmonia. Each shop becomes a real website, customizable in its layout, presentation, and visual identity, accessible both from the app and via a functional public link on the web — with no account required for visitors to browse the shop or its products.",
      "step1": {
        "title": "Create your shop",
        "desc": "From the Market, PRO members access their shop settings and publish it in just a few steps."
      },
      "step2": {
        "title": "Customize your website",
        "desc": "The design and many settings of the website associated with the shop can be adjusted to reflect the identity of the merchant, artisan, or entrepreneur."
      },
      "step3": {
        "title": "Publish products",
        "desc": "Each added product automatically gets its own page and web link, which can be viewed and shared independently of the shop."
      },
      "step4": {
        "title": "Be visible everywhere",
        "desc": "The shop link and each product's link can be shared on any platform, making it possible to sell and connect with customers worldwide."
      }
    },
    "proStatus": {
      "chip": "PRO STATUS",
      "title": "What PRO status unlocks",
      "p1": "PRO status allows more frequent posting (3 posts per day versus 1 for standard members), adding photos and videos to posts, sending media and voice notes in messages, and above all, creating an online shop with its own public website. A distinctive badge makes the status visible on the profile."
    },
    "faq": {
      "chip": "FREQUENTLY ASKED QUESTIONS",
      "title": "Frequently asked questions",
      "q1": {
        "question": "Is Harmonia World accessible everywhere in the world?",
        "answer": "Yes. Sign-up is open to anyone anywhere in the world, with no age restriction, and the platform is available on web and mobile."
      },
      "q2": {
        "question": "Are the contests games of chance?",
        "answer": "No. Harmonia World offers no games of chance. The sole objective of the contests is to reveal and reward genuine talent through community votes and, for finals, expert juries."
      },
      "q3": {
        "question": "Do I need a Harmonia account to browse a shop?",
        "answer": "No. Every published shop has a functional public link, viewable by any visitor without creating an account."
      },
      "q4": {
        "question": "What's the difference between a standard account and a PRO account?",
        "answer": "A PRO account allows more posting, adding richer media to posts and messages, and above all, creating an online shop with its own public website."
      }
    }
  }
}
